export function getErrorMessage(error: any): string {
    console.log(error);
    if (!error) {
        return "Erro desconhecido";
    }
    if (typeof error === 'string') {
        return error;
    }
    if (typeof error.data === 'string') {
        return error.data;
    }
    if (error.data && error.data.message) {
        return error.data.message;
    }
    return error?.message || "Erro desconhecido";
}

export async function errorDecoder(error: any): Promise<string> {
    console.log(error);

    if (error?.data instanceof Blob) {
        try {
            let jsonText = await error.data.text();
            let json = JSON.parse(jsonText);
            if (json?.message) {
                return json.message;
            }

            return await error.data.text();
        } catch (e) {
            console.error("Erro ao ler Blob:", e);
            return "Erro desconhecido.";
        }
    }

    if (error?.data instanceof ArrayBuffer) {
        try {
            let jsonText = new TextDecoder("utf-8").decode(error.data);
            let json = JSON.parse(jsonText);
            if (json?.message) {
                return json.message;
            }
            return jsonText;
        } catch (e) {
            console.error("Erro ao decodificar ArrayBuffer:", e);
            return "Erro desconhecido.";
        }
    }

    return String(error?.data ?? error);
}